var React = require('react');

function SquareCheckbox (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_3236","data-name":"Group 3236","transform":"translate(-1093 -440)"},[React.createElement("g",{"id":"Group_3234","data-name":"Group 3234","key":0},React.createElement("g",{"id":"Group_3235","data-name":"Group 3235"},React.createElement("rect",{"id":"Rectangle_464","data-name":"Rectangle 464","width":"24","height":"24","transform":"translate(1093 440)","fill":"#939bc0"}))),React.createElement("path",{"id":"Path_1843","data-name":"Path 1843","d":"M816.244,4359l4.182,4.182,8.762-8.763","transform":"translate(282.284 -3906.801)","fill":"none","stroke":"#fff","strokeWidth":"2","key":1})]));
}

SquareCheckbox.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = SquareCheckbox;

SquareCheckbox.default = SquareCheckbox;
